// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".v-btn--disabled[data-v-0672fee5]{pointer-events:unset;cursor:default}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/shared/SynchronizationForm.vue"],"names":[],"mappings":"AACA,kCACC,oBAAA,CACA,cAAA","file":"SynchronizationForm.vue","sourcesContent":["\n.v-btn--disabled {\n\tpointer-events: unset;\n\tcursor: default;\n}\n"]}]);
// Exports
module.exports = exports;
